const initialState = {
    ok: 0,
    ng: 0,
    unsorted: 0,
    total: 0
};

const manageDataCountsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case "SET_MANAGE_DATA_COUNTS":
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
};

export default manageDataCountsReducer;
